import './Message.css';

// Vendors
import React, {Component} from 'react';
import {CSSTransition} from 'react-transition-group';
import STATUS from '../Game/constants';

export default class Message extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fadeInMessage: false
    }
  }

  onAnimationEnd(event) {
    if (event.animationName === 'scaleUp') {
      this.setState({
        fadeInMessage: true
      })
    }

    if (event.animationName === 'fadeIn') {
      setTimeout(() => {
        this.props.callback();
        this.setState({
          fadeInMessage: false,
        })
      }, 750);
    }
  }

  render() {
    const fadeInClass = this.state.fadeInMessage ? 'fadeIn' : '';
    const messageClass = 'checkmark ' + fadeInClass;

    return (
      <CSSTransition
        in={this.props.status === STATUS.GAME_EXIT}
        timeout={350}
        classNames="fade"
        unmountOnExit
        onEntered={() => {

        }}
        onExited={() => {

        }}
      >
      <div className="Message">
        <div>
          <div className="greenBubble scaleUp" onAnimationEnd={this.onAnimationEnd.bind(this)}>
            <span className={messageClass}></span>
          </div>
          <p className={fadeInClass}>You've sorted <br/>them all! </p>
        </div>
      </div>
      </CSSTransition>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/rlgl/Message/Message.js